export type UpdateStepsValueEvent = CustomEvent<{
  type: StepsType;
  steps: number;
}>;

export enum StepsType {
  Before,
  After,
}
